import SplashLogo from '@/assets/icons/downTime_Logomark.svg?react';
import { Button } from '@/components/ui/button';
import { Frown } from 'lucide-react';
import React from 'react';

const Unauthorized: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-between p-6 text-center">
      <div className="mt-8">
        <SplashLogo />
      </div>
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center">
        <Frown className="text-foreground h-12 w-12 opacity-20" />
      </div>
      <div className="">
        <p className="mt-6 text-2xl font-bold">Unauthorized Access</p>
        <p className="mt-4 opacity-70">You are not authorized to view this content</p>
        <div className="mt-6 flex justify-center gap-4">
          <a href="/login">
            <Button variant={'enrich'} className="text-lg font-bold text-inherit">
              Login
            </Button>
          </a>
          <a href="/">
            <Button variant={'secondary'} className="text-lg font-bold text-inherit">
              Enrich App
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
